import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {promise} from 'selenium-webdriver';

@Injectable()
export class AuthGuardService implements CanActivateChild{
    url;
    constructor(private authentication: AuthenticationService, private router: Router) {
        this.url= this.authentication.getCookies('type');
    }
        canActivateChild(
            route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot
        ): Observable<boolean>|Promise<boolean>|boolean {
            let actualUrl = state.url;
                if ((!this.authentication.isAuthenticated()) || (actualUrl.indexOf(this.url)<0 && actualUrl.indexOf('/login')<0 && actualUrl != '/')){
                    this.router.navigate(['/login']);
                    return false;
                } else return true;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/auth-guard.service.ts